import createIcon from '../../createIcon';

/**
 * @component @name BrightnessLow
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfMjQwMl8yMDY3MikiPgo8cGF0aCBkPSJNMjAuMDAwNCAxNS4zMTA0TDIzLjMxMDQgMTIuMDAwNEwyMC4wMDA0IDguNjkwNDNWNC4wMDA0M0gxNS4zMTA0TDEyLjAwMDQgMC42OTA0M0w4LjY5MDQzIDQuMDAwNDNINC4wMDA0M1Y4LjY5MDQzTDAuNjkwNDMgMTIuMDAwNEw0LjAwMDQzIDE1LjMxMDRWMjAuMDAwNEg4LjY5MDQzTDEyLjAwMDQgMjMuMzEwNEwxNS4zMTA0IDIwLjAwMDRIMjAuMDAwNFYxNS4zMTA0Wk0xMi4wMDA0IDE4LjAwMDRDOC42OTA0MyAxOC4wMDA0IDYuMDAwNDMgMTUuMzEwNCA2LjAwMDQzIDEyLjAwMDRDNi4wMDA0MyA4LjY5MDQzIDguNjkwNDMgNi4wMDA0MyAxMi4wMDA0IDYuMDAwNDNDMTUuMzEwNCA2LjAwMDQzIDE4LjAwMDQgOC42OTA0MyAxOC4wMDA0IDEyLjAwMDRDMTguMDAwNCAxNS4zMTA0IDE1LjMxMDQgMTguMDAwNCAxMi4wMDA0IDE4LjAwMDRaIiBmaWxsPSJibGFjayIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzI0MDJfMjA2NzIiPgo8cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const BrightnessLow = createIcon('BrightnessLow', [
  ['g', { clipPath: 'url(#clip0_2402_20672)', key: '4ix9o8' }],
  ['defs', { key: '9ahrjx' }],
]);

export default BrightnessLow;
